import React from 'react';
import { nodeScriptReplace } from './ScriptUtil'

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    defaultHeader() {
        return (
            '<header class="main-header">' +
            '<a href="/" class="main-header__logo">' +
            'Alignment Healthcare Provider Tools' +
            '</a>' +
            '</header>'
        );
    }

    componentDidMount() {
        var get_HeaderGC = fetch('api/url?type=header');

        Promise.all([get_HeaderGC])
            .then((responses) =>
                Promise.all([responses[0].text()])
            )
            .then((data) => {
                const [headerHTML] = data;

                const containerHeader = document.getElementById('header-section');
                containerHeader.innerHTML = headerHTML;
                nodeScriptReplace(containerHeader);
            })
            .catch(() => {
                const containerHeader = document.getElementById('header-section');
                containerHeader.innerHTML = this.defaultHeader();
            })
            .finally(() => {
                document.getElementById('header-section').style.display = 'block';
            })
    }

    render() {
        return (
            <div>
                <div id="header-section" style={{ display: 'block' }}></div>
            </div>
        );
    }
}
